import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import {
  Button,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@roger/ui-components';

interface TablePaginationFooterProps {
  /** Zero-based page index. */
  pageIndex: number;
  pageCount: number;
  totalCount: number;
  pageSize: number;
  pageSizeOptions: number[];
  canPreviousPage: boolean;
  canNextPage: boolean;
  onPageSizeChange: (size: number) => void;
  onPreviousPage: () => void;
  onNextPage: () => void;
}

/** Shared "Rows per page · Page X of Y · N total · pager" table footer. */
const TablePaginationFooter: React.FC<TablePaginationFooterProps> = ({
  pageIndex,
  pageCount,
  totalCount,
  pageSize,
  pageSizeOptions,
  canPreviousPage,
  canNextPage,
  onPageSizeChange,
  onPreviousPage,
  onNextPage,
}) => (
  <div className='flex flex-wrap items-center gap-3 text-xs text-muted-foreground'>
    <div className='flex items-center gap-1.5'>
      <span>Rows per page</span>
      <Select
        value={String(pageSize)}
        onValueChange={(v: string) => onPageSizeChange(Number(v))}
      >
        <SelectTrigger selectSize='sm' className='w-[72px]'>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {pageSizeOptions.map(n => (
            <SelectItem key={n} value={String(n)}>
              {n}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
    <span className='ml-auto'>
      Page {pageIndex + 1} of {Math.max(1, pageCount)} · {totalCount} total
    </span>
    <div className='flex items-center gap-1'>
      <Button
        variant='outline'
        size='icon'
        className='h-7 w-7'
        disabled={!canPreviousPage}
        onClick={onPreviousPage}
        aria-label='Previous page'
      >
        <ChevronLeft className='h-4 w-4' />
      </Button>
      <Button
        variant='outline'
        size='icon'
        className='h-7 w-7'
        disabled={!canNextPage}
        onClick={onNextPage}
        aria-label='Next page'
      >
        <ChevronRight className='h-4 w-4' />
      </Button>
    </div>
  </div>
);

export default TablePaginationFooter;
